import React, { Component } from "react";
import PropTypes from "prop-types";
import ScriptTag from "@components/ScriptTag";
import { isServer } from "@lib/helpers";
import _get from "lodash/get";
import getConfig from "next/config";

import ContentEditorProductDescription from "@components/ProductPage/ProductDescription/ContentEditorProductDescription";
import StaticHTMLProductDescription from "@components/ProductPage/ProductDescription/StaticHTMLProductDescription";

const {
  publicRuntimeConfig: { contentProviders },
} = getConfig();

class FlixMediaProductDescription extends Component {
  // handleOnLoad = () => {
  //   if (typeof flixJsCallbacks === "object") {
  //     window.flixJsCallbacks.setLoadCallback(function() {
  //       try {
  //         document.getElementById("small-description").remove();
  //       } catch (e) {
  //         return;
  //       }
  //     });
  //   }
  // };

  render() {
    const { brand, ean, contentEditorBlock, staticHTML } = this.props;

    return (
      <>
        <div id="flix-minisite" />
        <div id="flix-inpage" />

        {/*
            Fallback content is hidden by CSS wizardry
            There is also a callback provided by FlixMedia if needed
            Check out handleOnLoad
        */}
        <div className="flixMediaContentFallback">
          {contentEditorBlock.length !== 0 ? (
            <ContentEditorProductDescription
              contentEditorBlock={contentEditorBlock}
              staticHTML={staticHTML}
              ean={ean}
              brand={brand}
            />
          ) : (
            <StaticHTMLProductDescription
              staticHTML={staticHTML}
              ean={ean}
              brand={brand}
            />
          )}
        </div>

        <style>{`
          .flixMediaContentFallback {
            display: none
          }

          .ek-aricon, #flix_hotspots, .flix_hotspotV2, .flix_hotspot_ro {
            display: none !important;
            top: -99999px;
            left: -99999px;
          }

          #flix-inpage:empty + .flixMediaContentFallback {
            display:block
          }
        `}</style>

        {!isServer && (
          <ScriptTag
            type="text/javascript"
            src="//media.flixfacts.com/js/loader.js"
            data-flix-distributor={_get(
              contentProviders,
              "providers.flixMedia.distributorCode",
              ""
            )}
            data-flix-language="ro"
            data-flix-brand={brand}
            data-flix-ean={ean}
            data-flix-button="flix-minisite"
            data-flix-inpage="flix-inpage"
            async
            // onLoad={this.handleOnLoad}
          />
        )}
      </>
    );
  }
}

FlixMediaProductDescription.propTypes = {
  staticHTML: PropTypes.string.isRequired,
  contentEditorBlock: PropTypes.string.isRequired,
  ean: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
};

export default FlixMediaProductDescription;
